import React from 'react';
import classNames from 'classnames';

const Flag = ({ children = '', className, size, style = {}, ...rest }) => {
  const imgStyle = {};

  if (size === 'sm') {
    imgStyle.height = '25px';
  }

  return (
    <div className={classNames('flag', className)} style={{ display: 'inline-block', ...style }} {...rest}>
      <img src={`/img/flags/${children.toLowerCase()}.svg`} style={imgStyle} />
    </div>
  );
};

export default Flag;
